module.exports = "images/doc-day-add-drag-print.95052bb441b1a08df8b20ac047336404.png";